/**
 * Create a wire adapter bound to an i18nStore.
 */
export function createWireI18n(i18nStore) {
  return class WireI18n {
    constructor(callback) {
      this.selectI18nStaticCache = state => {
        return this.selector ? this.selector(state.i18nStaticCache) : state.i18nStaticCache;
      };
      this.callback = callback;
    }
    // deliberate noop: all the magic happens in update
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    connect() {}
    update({
      selector
    }) {
      if (!this.subscription || this.selector !== selector) {
        this.unsubscribeFromStore();
        this.selector = selector;
        this.subscribeToStore();
      }
    }
    disconnect() {
      this.unsubscribeFromStore();
    }
    subscribeToStore() {
      this.subscription = i18nStore.subscribe(this.callback, this.selectI18nStaticCache);
      this.callback(this.selectI18nStaticCache(i18nStore.getState()));
    }
    unsubscribeFromStore() {
      if (this.subscription) {
        this.subscription();
        this.subscription = undefined;
      }
    }
  };
}